import { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { ProductImages } from "../Components/images/ProductImages";
import "./Specific.scss";
import { ProductDetails } from "./ProductDetails";
import { Reviews } from "./Reviews";
import { MoreDetails } from "./MoreDetails";
import { Products } from "../Products/Products";
import OfferSlider from "../Components/text-slider/offer";
import { PHONE_CASE_CATEGORY } from "../Products/data/phoneCaseFilters";

function buildProductBreadcrumbs(product) {
  const category = product?.category || PHONE_CASE_CATEGORY;
  const subcategory = product?.subcategory || "";
  const brand = product?.brand || "";
  const title = product?.title || "Product";
  const listingPath = subcategory
    ? `/products/${encodeURIComponent(category)}/${encodeURIComponent(subcategory)}`
    : "/";

  const crumbs = [
    { label: "Home", to: "/" },
    { label: category, to: listingPath },
  ];

  if (brand) {
    crumbs.push({ label: brand, to: listingPath });
  }

  crumbs.push({ label: title, current: true });
  return crumbs;
}

export function Specific() {
  const { product_id } = useParams();
  const [product, setProduct] = useState(null);

  useEffect(() => {
    if (!product_id) return undefined;
    let cancelled = false;
    const token = localStorage.getItem("token");
    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};

    axios
      .post(`/products/specifications/${product_id}`, {}, config)
      .then((res) => {
        if (!cancelled) setProduct(res.data || null);
      })
      .catch((err) => {
        if (!cancelled) setProduct(null);
        console.error("Failed to fetch product for breadcrumbs:", err);
      });

    return () => {
      cancelled = true;
    };
  }, [product_id]);

  const breadcrumbs = useMemo(
    () => buildProductBreadcrumbs(product),
    [product]
  );

  return (
    <div className="specific-web">
      <div className="breadcrumbs-container">
        <nav aria-label="Breadcrumb">
          {breadcrumbs.map((crumb, index) => (
            <span key={`${crumb.label}-${index}`}>
              {index > 0 && <span className="breadcrumbs-separator">/</span>}
              {crumb.current ? (
                <span className="breadcrumbs-bold-link breadcrumbs-current" aria-current="page">
                  {crumb.label}
                </span>
              ) : (
                <Link to={crumb.to} className="breadcrumbs-link">
                  {crumb.label}
                </Link>
              )}
            </span>
          ))}
        </nav>
        <OfferSlider />
      </div>
      <div className="top-section">
        <div className="prod-left-images">
          <ProductImages product_id={product_id} />
        </div>
        <div className="prod-right-details">
          <ProductDetails product_id={product_id} />
        </div>
      </div>

      <div className="midsection">
        <div className="review-section">
          <Reviews product_id={product_id} />
        </div>

        <div className="moreDetails">
          <MoreDetails />
        </div>
      </div>

      <div className="all-products">
        <header className="all-products__header">
          <h2 className="all-products__title">All products</h2>
        </header>
        <Products hideOptions={true} />
      </div>

    </div>
  );
}
